import React from 'react';
import '../components/css/popupstyle.css';
import $ from 'jquery';

class ConfirmDeletePopup extends React.Component {

    constructor(props) {
        super(props);
    }  

    render() {
        return (

            <div className='tool-section report confirmClose'>
                <div className='popup report-section'>
                    <div className='popup_inner'>

                        <h1>{this.props.titleText}</h1>
                        <form>

                            <div className="pop-btn">
                                <button className="btn" onClick={this.props.handleDashboard}>Yes</button>
                                <button className="btn cancel" onClick={this.props.closePopup}>No</button>
                            </div>

                        </form>

                    </div>
                </div>
            </div>

        )
    }
}

export default ConfirmDeletePopup;